<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-form ref="formTransferValidation" role="form">
			<v-card>
				<v-card-title class="h6 justify-start">Konfirmasi</v-card-title>
				<v-card-text class="text-left">
					<div class="d-block text-left mb-3" v-if="Object.keys(msg).length > 0">
						<div class="d-flex">
							<div class="pa-0 col-6 col-sm-4">Kode Penerima</div>
							<div class="pa-0 col-6 col-sm-8 font-weight-bold text-uppercase">: {{ msg.code }}</div>
						</div>
						<div class="pt-1 d-flex">
							<div class="pa-0 col-6 col-sm-4">Nama Penerima</div>
							<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.name }}</div>
						</div>
						<div class="pt-1 d-flex">
							<div class="pa-0 col-6 col-sm-4">Nominal Transfer</div>
							<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ msg.nominal | toRupiah }}</div>
						</div>
					</div>
					<div class="d-block black--text pt-5">Apakah data transaksi saldo diatas sudah benar?<br>Jika <b>benar</b> lanjutkan dengan mengisi PIN, kemudian tekan tombol <b class="cl-primary">Submit</b> untuk memproses transfer saldo Anda.</div>
					<v-sheet outlined :color="(isEmptyPin) ? 'red' : 'primary'" rounded class="mt-4 mb-2 pa-50">
						<v-card outlined elevation="0" class="px-5 pt-3 pb-5">
							<v-text-field id="setPin" ref="setPin" label="Masukkan PIN Anda" class="input-regis" prepend-inner-icon="mdi-lock" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" @input="checkValidPin" @focus="$event.target.select()" hide-details="auto" :rules="rules.setPin" v-model="setPin" autofocus></v-text-field>
						</v-card>
					</v-sheet>
				</v-card-text>
				<v-card-actions class="pb-4">
					<v-spacer></v-spacer>
					<v-btn color="primary" depressed class="text-capitalize" :disabled="!setPin" :loading="btnLoading" @click.stop="confirm">{{ confirmText }}</v-btn>
					<v-btn color="grey darken-1" outlined class="text-capitalize" :loading="btnLoading" @click.stop="modalHide">{{ closeText }}</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			setPin: '',
			typeInput0: 'password',
			icon0: 'mdi-eye',
			isEmptyPin: true,
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Batal',
			confirmText: 'Submit',
			rules: {
				setPin: [
					v => !!v || 'PIN tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "PIN tidak boleh kurang dari 6 angka",
				],
			},
		}
	},
	props: {
		msg: Object,
	},
	computed: {
	},
	methods: {
		showPassword0() {
			this.typeInput0 = this.typeInput0 == 'text' ? 'password' : 'text'
			this.icon0 = this.icon0 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		checkValidPin() {
			if (this.setPin) {
				if (this.setPin.length < 6) this.isEmptyPin = true
				else this.isEmptyPin = false
			} else {
				this.isEmptyPin = true
			}
		},
		modalHide() {
			this.setPin = ''
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		loadingButton() {
			this.btnLoading = true
		},
		normalButton() {
			this.btnLoading = false
		},
		async confirm() {
			if (this.$refs.formTransferValidation.validate()) {
				this.$parent.params.ewallet_sender_pin = await this.setPin
				await this.$emit('action')
				// setTimeout(()=>{ 
				// 	this.setPin = ''
				// }, 500)
			}
		}
	},
	mounted() {
	},
};
</script>